var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.8 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laptop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b3c35bff-9da7-45e4-bb3d-568360ebcb4f",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bfadb0a2-8614-4073-a21e-181ff47c56d4",
    "data-name": "WOMAN'S LAPTOP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.63,73.31A5.7,5.7,0,0,1,77.94,79H5.7a5.69,5.69,0,1,1,0-11.38H77.94A5.69,5.69,0,0,1,83.63,73.31Z",
    fill: "#0085cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.63,73.31A5.7,5.7,0,0,1,77.94,79h-35c6.28-3.92,12-8.17,17.58-11.38H77.94A5.69,5.69,0,0,1,83.63,73.31Z",
    fill: "#005d8f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.02,
    y: 71.28,
    width: 11.15,
    height: 4.05,
    rx: 2.03,
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.85,
    y: 71.28,
    width: 11.15,
    height: 4.05,
    rx: 2.03,
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,79h-76a6.3,6.3,0,0,1-6-8.29L92.78,6.86A10,10,0,0,1,102.29,0h76a6.29,6.29,0,0,1,6,8.29L163,72.14A10,10,0,0,1,153.5,79Z",
    fill: "#003049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,8.29l-2,5.91L169.19,72.14A10,10,0,0,1,159.67,79h-76a6.3,6.3,0,0,1-6-8.29l4.16-12.46L99,6.86A10,10,0,0,1,108.46,0h76A6.29,6.29,0,0,1,190.47,8.29Z",
    fill: "#0085cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5,14.2,169.19,72.14A10,10,0,0,1,159.67,79h-76a6.3,6.3,0,0,1-6-8.29l4.16-12.46c10.3-6,24.91-10.68,47.22-14.67C158.93,38.24,178.36,24.24,188.5,14.2Z",
    fill: "#005d8f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.176c0112.svg";
export { ForwardRef as ReactComponent };